import {makeQRCode} from '@solid-integrations/qrcode-generator'
import {useI18n} from '../../i18n'
import {useIcon} from '../icon/useIcon'
import './whereIsMyUsername.css'
import {FocusGroupProvider, FocusableProvider} from '../focus/index'
import { onMount } from 'solid-js'
import { isPlatform } from '../../utils'
import { useSpatialNavigation } from '../../spatialNavigation'

interface WhereIsMyUsernameProps {
    onLoginTVUsernameClose: () => void;
}

const WhereIsMyUsername = (props:WhereIsMyUsernameProps) => {
    const icons = useIcon()
    const {getI18n} = useI18n()
    const {setFocus} = useSpatialNavigation()

    const qrCode = makeQRCode('http://ore.do/tvapp')

    const handleUsernameClose = () => {
        // Perform login (Here you might make an API call to validate credentials)
        props?.onLoginTVUsernameClose && props?.onLoginTVUsernameClose()
    }

    onMount(() => {
        !isPlatform('laptop') && setFocus('usernameclosebutton')
    })

    return (
        <FocusGroupProvider id={`whereIsUserNameContainer-screen`} focusKey={`whereIsUserNameContainer-screen`} onFocus={() => {}}>

        <div
            class="appContainerUsername"
            style={{
                'background-image': `url(${icons.get('LoginBackdrop')})`,
                'background-size': 'cover',
            }}
        >
            <div class="whereIsUserNameContainer">
                <div class="client_logo_loading_logout_screen"></div>
                <div class="qr-description-where-is-my-username">
                    {getI18n()?.formatMessage({id: 'SCAN_TO_FIND_YOUR_USERNAME'})}
                </div>
                <div >
                    <img src={qrCode} alt={''} class={'qr-code-container-where-is-my-username'} loading={'lazy'} />
                </div>
                <FocusableProvider
                    id={'usernameclosebutton'}
                    focusKey={`usernameclosebutton`}
                    onEnterPress={() => handleUsernameClose()}
                    onFocus={() => {
                        
                    }}
                >
                    {(focused: any) => (
                        <button
                            id="loginusernameclosebutton"
                            class={`login-content-button-username-close-tv ${focused?.() ? 'login-content-button-tv-username-close-focus' : ''}`}
                            tabIndex={focused?.() ? 0 : -1}
                            type="submit"
                            onClick={()=>{
                                handleUsernameClose()
                                }
                            }
                        >
                            {getI18n()?.formatMessage({id: 'BACK'})}
                        </button>
                    )}
                </FocusableProvider>
            </div>
        </div>
        </FocusGroupProvider>
    )
}

export default WhereIsMyUsername
